import BaseShowCase from "@/views/ShowCase/BaseShowCase";
import showcase from "@/views/ShowCase/index";
import live from "@/views/ShowCase/Live";
import demoveRemBkgr from "@/views/ShowCase/DemoveRemBkgr";
import InteractiveVideo from "@/views/ShowCase/InteractiveVideo";
import CountClick from "@/views/ShowCase/CountClick";
import ContextualAdvertising from "@/views/ShowCase/ContextualAdvertising";
import showCaseAllModel from "@/views/ShowCase/ShowCaseAllModel";
import PosterImages from "@/views/ShowCase/PosterImages";
import DemoGameUI from "@/views/ShowCase/DemoGame/DemoGameUI";
import ScreenMission from "@/views/ShowCase/DemoGame/ScreenMission";
import AwardMision from "@/views/ShowCase/DemoGame/ScreenAward/Layout";
const route = {
  path: "/showcase",
  name: "BaseShowCase",
  redirect: "/showcase/list",
  component: BaseShowCase,
  props: (route) => Object.assign({}, route.query, route.params),
  children: [
    {
      path: "/showcase/list",
      name: "ShowCase",
      component: showcase,
      props: (route) => Object.assign({}, route.query, route.params),
      meta: {
        title: "List Showcase",
        keepAlive: true,
      },
    },
    {
      path: "/showcase/livestream",
      name: "LiveStream",
      meta: {
        title: "Livestream",
        keepAlive: true,
      },
      component: live,
      props: (route) => Object.assign({}, route.query, route.params),
    },
    {
      path: "/showcase/demo-live-stream",
      name: "DemoveRemBkgr",
      meta: {
        title: "Demo Livestream",
        keepAlive: true,
      },
      component: demoveRemBkgr,
      // props: (route) => Object.assign({}, route.query, route.params),
    },
    {
      path: "/showcase/interactive-video",
      name: "InteractiveVideo",
      meta: {
        title: "Interactive Video",
        keepAlive: true,
      },
      component: InteractiveVideo,
      props: (route) => Object.assign({}, route.query, route.params),
    },
    {
      path: "/showcase/count-click",
      name: "CountClick",
      meta: {
        title: "Count Click Products in Video",
        keepAlive: true,
      },
      component: CountClick,
      props: (route) => Object.assign({}, route.query, route.params),
    },
    {
      path: "/showcase/contextual-advertising",
      name: "ContextualAdvertising",
      component: ContextualAdvertising,
      props: (route) => Object.assign({}, route.query, route.params),
      meta: {
        title: "Contextual Advertising",
        keepAlive: true,
      },
    },
    {
      path: "/showcase/all-models",
      name: "ShowCaseAllModel",
      meta: {
        title: "ShowCase AllModel",
        keepAlive: true,
      },
      component: showCaseAllModel,
      props: (route) => Object.assign({}, route.query, route.params),
    },
    {
      path: "/showcase/poster-images",
      name: "PosterImages",
      meta: {
        title: "Poster Images",
        keepAlive: true,
      },
      component: PosterImages,
      props: (route) => Object.assign({}, route.query, route.params),
    },
    {
      path: "/showcase/demo-game-ui",
      name: "DemoGameUI",
      meta: {
        title: "DemoGameUI",
        keepAlive: false,
      },
      component: DemoGameUI,
      props: (route) => Object.assign({}, route.query, route.params),
    },
    {
      path: "/showcase/screen-mission",
      name: "ScreenMission",
      meta: {
        title: "ScreenMission",
        keepAlive: false,
      },
      component: ScreenMission,
      props: (route) => Object.assign({}, route.query, route.params),
    },
    {
      path: "/showcase/screen-award-mission",
      name: "AwardMision",
      meta: {
        title: "AwardMision",
        keepAlive: false,
      },
      component: AwardMision,
      props: (route) => Object.assign({}, route.query, route.params),
    },
  ],
};
export default route;
